const options = {
    summaryCredit: [
        {
            label: 'Monto solicitado',
            name: 'monto',
        },
        {
            label: 'Centrales de riesgo',
            name: 'central_de_riesgo',
        },
        {
            label: 'Adquisición GPS ',
            name: 'valor_adquisicion_gps',
        },
        {
            label: 'Comisión miPyme',
            name: 'comision',
        },
        {
            label: 'Comisión estudio',
            name: 'comision_estudio',
        },
        {
            label: 'Garantía mobiliaria',
            name: 'garantia_mobiliaria',
        },
        {
            label: 'Gastos de desembolso',
            name: 'gastos_transaccionales',
        },
        {
            label: 'Fondo de garantías',
            name: 'fondo_garantias',
        },
        {
            label: 'Seguro agrícola',
            name: 'valor_seguro_agricola',
        },
    ],
    monthlyValues: [
        {
            label: 'Cuota mensual',
            name: 'mensualidad',
        },
        {
            label: 'Seguro de vida deudor',
            name: 'valor_seguro_deudor',
        },
        {
            label: 'Seguro voluntario',
            name: 'valor_seguro_voluntario',
        },
        {
            label: 'Seguro todo riesgo',
            name: 'valor_seguro_todo_riesgo',
        },
        {
            label: 'Seguro todo riesgo maquinaria',
            name: 'valor_seguro_todo_riesgo_maquinaria',
        },
        {
            label: 'Seguro SBS',
            name: 'valor_seguro_sbs',
        },
        {
            label: 'Seguro Agro',
            name: 'valor_seguro_agro',
        },
        {
            label: 'Mensualidad GPS',
            name: 'valor_mensualidad_gps',
        },
    ],
};

export default options;
